<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const sortAlpha = computed(() => store.state.themes.sortAlpha);

// --- Methods ---

const toggleSortAlpha = () => {
    store.commit('themes/toggleSortAlpha');
};
</script>

<template>
    <Button @click.native="toggleSortAlpha" :active-value="sortAlpha" class="btn-sm">
        <i class="bi bi-sort-alpha-down"/>
    </Button>
</template>